(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './Stately-stately-concurrency.js', './Stately-stately-concurrent-collections.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./Stately-stately-concurrency.js'), require('./Stately-stately-concurrent-collections.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'projects-core-koin-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'projects-core-koin-core'.");
    }
    if (typeof this['Stately-stately-concurrency'] === 'undefined') {
      throw new Error("Error loading module 'projects-core-koin-core'. Its dependency 'Stately-stately-concurrency' was not found. Please, check whether 'Stately-stately-concurrency' is loaded prior to 'projects-core-koin-core'.");
    }
    if (typeof this['Stately-stately-concurrent-collections'] === 'undefined') {
      throw new Error("Error loading module 'projects-core-koin-core'. Its dependency 'Stately-stately-concurrent-collections' was not found. Please, check whether 'Stately-stately-concurrent-collections' is loaded prior to 'projects-core-koin-core'.");
    }
    root['projects-core-koin-core'] = factory(typeof this['projects-core-koin-core'] === 'undefined' ? {} : this['projects-core-koin-core'], this['kotlin-kotlin-stdlib'], this['Stately-stately-concurrency'], this['Stately-stately-concurrent-collections']);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_co_touchlab_stately_concurrency, kotlin_co_touchlab_stately_concurrent_collections) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var protoOf = kotlin_kotlin.$_$.hb;
  var Pair = kotlin_kotlin.$_$.le;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ia;
  var toList = kotlin_kotlin.$_$.m8;
  var initMetadataForInterface = kotlin_kotlin.$_$.ka;
  var VOID = kotlin_kotlin.$_$.g;
  var emptyList = kotlin_kotlin.$_$.s6;
  var toString = kotlin_kotlin.$_$.pf;
  var toString_0 = kotlin_kotlin.$_$.lb;
  var equals = kotlin_kotlin.$_$.z9;
  var joinToString = kotlin_kotlin.$_$.i7;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  var hashCode = kotlin_kotlin.$_$.ga;
  var Enum = kotlin_kotlin.$_$.ee;
  var Exception = kotlin_kotlin.$_$.ge;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.j1;
  var captureStack = kotlin_kotlin.$_$.r9;
  var Exception_init_$Init$_0 = kotlin_kotlin.$_$.k1;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.o;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.u1;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.r;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.l;
  var getKClassFromExpression = kotlin_kotlin.$_$.e;
  var getStringHashCode = kotlin_kotlin.$_$.fa;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.w;
  var get_lastIndex = kotlin_kotlin.$_$.l7;
  var toList_0 = kotlin_kotlin.$_$.l8;
  var copyToArray = kotlin_kotlin.$_$.o6;
  var arrayListOf = kotlin_kotlin.$_$.v5;
  var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.j;
  var ThreadLocalRef = kotlin_co_touchlab_stately_concurrency.$_$.a;
  var initMetadataForObject = kotlin_kotlin.$_$.ma;
  var Monotonic_instance = kotlin_kotlin.$_$.v4;
  var ValueTimeMark__elapsedNow_impl_eonqvs = kotlin_kotlin.$_$.l2;
  var _Duration___get_inWholeNanoseconds__impl__r5x4mr = kotlin_kotlin.$_$.j2;
  var Exception_init_$Create$ = kotlin_kotlin.$_$.i1;
  var split = kotlin_kotlin.$_$.dd;
  var Default_getInstance = kotlin_kotlin.$_$.s4;
  var getNumberHashCode = kotlin_kotlin.$_$.da;
  var LazyThreadSafetyMode_NONE_getInstance = kotlin_kotlin.$_$.h;
  var ConcurrentMutableMap_init_$Create$ = kotlin_co_touchlab_stately_concurrent_collections.$_$.a;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Koin, 'Koin', Koin);
  initMetadataForCompanion(Companion);
  initMetadataForClass(KoinApplication, 'KoinApplication');
  function getKoin() {
    return KoinPlatformTools_instance.q2f().os();
  }
  initMetadataForInterface(KoinComponent, 'KoinComponent');
  initMetadataForInterface(KoinScopeComponent, 'KoinScopeComponent', VOID, VOID, [KoinComponent]);
  initMetadataForClass(BeanDefinition, 'BeanDefinition');
  initMetadataForClass(Kind, 'Kind', VOID, Enum);
  initMetadataForClass(Callbacks, 'Callbacks', Callbacks);
  initMetadataForClass(KoinDefinition, 'KoinDefinition');
  initMetadataForClass(ClosedScopeException, 'ClosedScopeException', VOID, Exception);
  initMetadataForClass(DefinitionOverrideException, 'DefinitionOverrideException', VOID, Exception);
  initMetadataForClass(InstanceCreationException, 'InstanceCreationException', VOID, Exception);
  initMetadataForClass(KoinAppAlreadyStartedException, 'KoinAppAlreadyStartedException', VOID, Exception);
  initMetadataForClass(NoBeanDefFoundException, 'NoBeanDefFoundException', VOID, Exception);
  initMetadataForClass(ExtensionManager, 'ExtensionManager');
  initMetadataForClass(InstanceContext, 'InstanceContext');
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(InstanceFactory, 'InstanceFactory');
  initMetadataForClass(SingleInstanceFactory, 'SingleInstanceFactory', VOID, InstanceFactory);
  initMetadataForClass(Logger, 'Logger');
  initMetadataForClass(EmptyLogger, 'EmptyLogger', EmptyLogger, Logger);
  initMetadataForClass(Level, 'Level', VOID, Enum);
  initMetadataForClass(Module, 'Module', Module);
  initMetadataForClass(ParametersHolder, 'ParametersHolder', ParametersHolder);
  initMetadataForClass(StringQualifier, 'StringQualifier');
  initMetadataForClass(InstanceRegistry, 'InstanceRegistry');
  initMetadataForClass(PropertyRegistry, 'PropertyRegistry');
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(ScopeRegistry, 'ScopeRegistry');
  initMetadataForClass(Scope, 'Scope');
  initMetadataForCompanion(Companion_2);
  initMetadataForObject(GlobalContext, 'GlobalContext');
  initMetadataForObject(KoinPlatformTimeTools, 'KoinPlatformTimeTools');
  initMetadataForObject(KoinPlatformTools, 'KoinPlatformTools');
  //endregion
  function Koin() {
    this.n2e_1 = new ScopeRegistry(this);
    this.o2e_1 = new InstanceRegistry(this);
    this.p2e_1 = new PropertyRegistry(this);
    this.q2e_1 = new ExtensionManager(this);
    this.r2e_1 = new EmptyLogger();
  }
  protoOf(Koin).s2e = function (modules, allowOverride, createEagerInstances) {
    var flattedModules = flatten(modules);
    this.o2e_1.w2e(flattedModules, allowOverride);
    this.n2e_1.b2f(flattedModules);
    if (createEagerInstances) {
      this.c2f();
    }
  };
  protoOf(Koin).c2f = function () {
    this.r2e_1.e2f('Create eager instances ...');
    // Inline function 'org.koin.core.time.measureDuration' call
    // Inline function 'org.koin.core.time.measureTimedValue' call
    var start = KoinPlatformTimeTools_instance.f2f();
    this.o2e_1.g2f();
    var value = Unit_instance;
    var stop = KoinPlatformTimeTools_instance.f2f();
    // Inline function 'kotlin.Long.div' call
    var tmp$ret$0 = stop.m2(start).d3() / 1000000.0;
    var duration = (new Pair(value, tmp$ret$0)).ud_1;
    this.r2e_1.e2f('Created eager instances in ' + duration + ' ms');
  };
  function loadModules($this, modules) {
    $this.h2f_1.s2e(modules, $this.i2f_1, false);
  }
  function Companion() {
  }
  protoOf(Companion).j2f = function () {
    var app = new KoinApplication();
    return app;
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function KoinApplication() {
    this.h2f_1 = new Koin();
    this.i2f_1 = true;
  }
  protoOf(KoinApplication).k2f = function (modules) {
    return this.l2f(toList(modules));
  };
  protoOf(KoinApplication).l2f = function (modules) {
    if (this.h2f_1.r2e_1.o2f(Level_INFO_getInstance())) {
      // Inline function 'org.koin.core.time.measureDuration' call
      // Inline function 'org.koin.core.time.measureTimedValue' call
      var start = KoinPlatformTimeTools_instance.f2f();
      loadModules(this, modules);
      var value = Unit_instance;
      var stop = KoinPlatformTimeTools_instance.f2f();
      // Inline function 'kotlin.Long.div' call
      var tmp$ret$0 = stop.m2(start).d3() / 1000000.0;
      var duration = (new Pair(value, tmp$ret$0)).ud_1;
      var count = this.h2f_1.o2e_1.m2f();
      this.h2f_1.r2e_1.n2f(Level_INFO_getInstance(), 'Started ' + count + ' definitions in ' + duration + ' ms');
    } else {
      loadModules(this, modules);
    }
    return this;
  };
  function KoinComponent() {
  }
  function KoinScopeComponent() {
  }
  function startKoin(appDeclaration) {
    return KoinPlatformTools_instance.q2f().s2f(appDeclaration);
  }
  function BeanDefinition$toString$lambda(it) {
    return getFullName(it);
  }
  function BeanDefinition(scopeQualifier, primaryType, qualifier, definition, kind, secondaryTypes) {
    qualifier = qualifier === VOID ? null : qualifier;
    var tmp;
    if (secondaryTypes === VOID) {
      // Inline function 'kotlin.collections.listOf' call
      tmp = emptyList();
    } else {
      tmp = secondaryTypes;
    }
    secondaryTypes = tmp;
    this.t2f_1 = scopeQualifier;
    this.u2f_1 = primaryType;
    this.v2f_1 = qualifier;
    this.w2f_1 = definition;
    this.x2f_1 = kind;
    this.y2f_1 = secondaryTypes;
    this.z2f_1 = new Callbacks();
    this.a2g_1 = false;
  }
  protoOf(BeanDefinition).toString = function () {
    var defKind = this.x2f_1.toString();
    var defType = "'" + getFullName(this.u2f_1) + "'";
    var tmp;
    if (this.v2f_1 == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'org.koin.core.definition.BeanDefinition.toString.<anonymous>' call
      tmp = ',qualifier:' + toString(this.v2f_1);
    }
    var tmp1_elvis_lhs = tmp;
    var defName = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.koin.core.definition.BeanDefinition.toString.<anonymous>' call
    var it = this.t2f_1;
    var defScope = equals(it, Companion_getInstance_1().c2g_1) ? '' : ',scope:' + toString_0(this.t2f_1);
    var tmp_0;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.y2f_1.o()) {
      var tmp_1 = this.y2f_1;
      var typesAsString = joinToString(tmp_1, ',', VOID, VOID, VOID, VOID, BeanDefinition$toString$lambda);
      tmp_0 = ',binds:' + typesAsString;
    } else {
      tmp_0 = '';
    }
    var defOtherTypes = tmp_0;
    return '[' + defKind + ':' + defType + defName + defScope + defOtherTypes + ']';
  };
  protoOf(BeanDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BeanDefinition))
      THROW_CCE();
    if (!this.u2f_1.equals(other.u2f_1))
      return false;
    if (!equals(this.v2f_1, other.v2f_1))
      return false;
    if (!equals(this.t2f_1, other.t2f_1))
      return false;
    return true;
  };
  protoOf(BeanDefinition).hashCode = function () {
    var tmp0_safe_receiver = this.v2f_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    result = imul(31, result) + this.u2f_1.hashCode() | 0;
    result = imul(31, result) + hashCode(this.t2f_1) | 0;
    return result;
  };
  function indexKey(clazz, typeQualifier, scopeQualifier) {
    var tmp1_elvis_lhs = typeQualifier == null ? null : typeQualifier.v();
    var tq = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    return getFullName(clazz) + ':' + tq + ':' + toString_0(scopeQualifier);
  }
  var Kind_Singleton_instance;
  var Kind_Factory_instance;
  var Kind_Scoped_instance;
  var Kind_entriesInitialized;
  function Kind_initEntries() {
    if (Kind_entriesInitialized)
      return Unit_instance;
    Kind_entriesInitialized = true;
    Kind_Singleton_instance = new Kind('Singleton', 0);
    Kind_Factory_instance = new Kind('Factory', 1);
    Kind_Scoped_instance = new Kind('Scoped', 2);
  }
  function Kind(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Kind_Singleton_getInstance() {
    Kind_initEntries();
    return Kind_Singleton_instance;
  }
  function Callbacks(onClose) {
    onClose = onClose === VOID ? null : onClose;
    this.d2g_1 = onClose;
  }
  protoOf(Callbacks).toString = function () {
    return 'Callbacks(onClose=' + toString(this.d2g_1) + ')';
  };
  protoOf(Callbacks).hashCode = function () {
    return this.d2g_1 == null ? 0 : hashCode(this.d2g_1);
  };
  protoOf(Callbacks).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Callbacks))
      return false;
    var tmp0_other_with_cast = other instanceof Callbacks ? other : THROW_CCE();
    if (!equals(this.d2g_1, tmp0_other_with_cast.d2g_1))
      return false;
    return true;
  };
  function KoinDefinition(module_0, factory) {
    this.e2g_1 = module_0;
    this.f2g_1 = factory;
  }
  protoOf(KoinDefinition).toString = function () {
    return 'KoinDefinition(module=' + toString_0(this.e2g_1) + ', factory=' + toString_0(this.f2g_1) + ')';
  };
  protoOf(KoinDefinition).hashCode = function () {
    var result = this.e2g_1.hashCode();
    result = imul(result, 31) + this.f2g_1.hashCode() | 0;
    return result;
  };
  protoOf(KoinDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof KoinDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof KoinDefinition ? other : THROW_CCE();
    if (!this.e2g_1.equals(tmp0_other_with_cast.e2g_1))
      return false;
    if (!this.f2g_1.equals(tmp0_other_with_cast.f2g_1))
      return false;
    return true;
  };
  function ClosedScopeException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, ClosedScopeException);
  }
  function DefinitionOverrideException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, DefinitionOverrideException);
  }
  function InstanceCreationException(msg, parent) {
    Exception_init_$Init$_0(msg, parent, this);
    captureStack(this, InstanceCreationException);
  }
  function KoinAppAlreadyStartedException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, KoinAppAlreadyStartedException);
  }
  function NoBeanDefFoundException(msg) {
    Exception_init_$Init$(msg, this);
    captureStack(this, NoBeanDefFoundException);
  }
  function ExtensionManager(_koin) {
    this.g2g_1 = _koin;
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.h2g_1 = HashMap_init_$Create$();
  }
  function InstanceContext(logger, scope, parameters) {
    parameters = parameters === VOID ? null : parameters;
    this.i2g_1 = logger;
    this.j2g_1 = scope;
    this.k2g_1 = parameters;
  }
  function Companion_0() {
    this.l2g_1 = '\n\t';
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function InstanceFactory(beanDefinition) {
    this.m2g_1 = beanDefinition;
  }
  protoOf(InstanceFactory).o2g = function (context) {
    context.i2g_1.e2f("| (+) '" + this.m2g_1.toString() + "'");
    try {
      var tmp0_elvis_lhs = context.k2g_1;
      var parameters = tmp0_elvis_lhs == null ? emptyParametersHolder() : tmp0_elvis_lhs;
      return this.m2g_1.w2f_1(context.j2g_1, parameters);
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        var stack = KoinPlatformTools_instance.p2g(e);
        context.i2g_1.q2g("* Instance creation error : could not create instance for '" + this.m2g_1.toString() + "': " + stack);
        throw new InstanceCreationException("Could not create instance for '" + this.m2g_1.toString() + "'", e);
      } else {
        throw $p;
      }
    }
  };
  protoOf(InstanceFactory).equals = function (other) {
    var tmp0_safe_receiver = other instanceof InstanceFactory ? other : null;
    var other_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m2g_1;
    return this.m2g_1.equals(other_0);
  };
  protoOf(InstanceFactory).hashCode = function () {
    return this.m2g_1.hashCode();
  };
  function getValue($this) {
    var tmp0_elvis_lhs = $this.s2g_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = "Single instance created couldn't return value";
      throw IllegalStateException_init_$Create$(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function SingleInstanceFactory$get$lambda(this$0, $context) {
    return function () {
      var tmp;
      if (!this$0.t2g($context)) {
        this$0.s2g_1 = this$0.o2g($context);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function SingleInstanceFactory(beanDefinition) {
    InstanceFactory.call(this, beanDefinition);
    this.s2g_1 = null;
  }
  protoOf(SingleInstanceFactory).t2g = function (context) {
    return !(this.s2g_1 == null);
  };
  protoOf(SingleInstanceFactory).o2g = function (context) {
    var tmp;
    if (this.s2g_1 == null) {
      tmp = protoOf(InstanceFactory).o2g.call(this, context);
    } else {
      tmp = getValue(this);
    }
    return tmp;
  };
  protoOf(SingleInstanceFactory).n2g = function (context) {
    var tmp = KoinPlatformTools_instance;
    tmp.u2g(this, SingleInstanceFactory$get$lambda(this, context));
    return getValue(this);
  };
  function EmptyLogger() {
    Logger.call(this, Level_NONE_getInstance());
  }
  protoOf(EmptyLogger).n2f = function (level, msg) {
  };
  function Logger(level) {
    level = level === VOID ? Level_INFO_getInstance() : level;
    this.d2f_1 = level;
  }
  protoOf(Logger).e2f = function (msg) {
    this.x2g(Level_DEBUG_getInstance(), msg);
  };
  protoOf(Logger).w2g = function (msg) {
    this.x2g(Level_WARNING_getInstance(), msg);
  };
  protoOf(Logger).q2g = function (msg) {
    this.x2g(Level_ERROR_getInstance(), msg);
  };
  protoOf(Logger).o2f = function (lvl) {
    return this.d2f_1.g2(lvl) <= 0;
  };
  protoOf(Logger).x2g = function (lvl, msg) {
    if (this.o2f(lvl)) {
      this.n2f(lvl, msg);
    }
  };
  protoOf(Logger).y2g = function (lvl, msg) {
    if (this.o2f(lvl)) {
      this.n2f(lvl, msg());
    }
  };
  var Level_DEBUG_instance;
  var Level_INFO_instance;
  var Level_WARNING_instance;
  var Level_ERROR_instance;
  var Level_NONE_instance;
  var Level_entriesInitialized;
  function Level_initEntries() {
    if (Level_entriesInitialized)
      return Unit_instance;
    Level_entriesInitialized = true;
    Level_DEBUG_instance = new Level('DEBUG', 0);
    Level_INFO_instance = new Level('INFO', 1);
    Level_WARNING_instance = new Level('WARNING', 2);
    Level_ERROR_instance = new Level('ERROR', 3);
    Level_NONE_instance = new Level('NONE', 4);
  }
  function Level(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Level_DEBUG_getInstance() {
    Level_initEntries();
    return Level_DEBUG_instance;
  }
  function Level_INFO_getInstance() {
    Level_initEntries();
    return Level_INFO_instance;
  }
  function Level_WARNING_getInstance() {
    Level_initEntries();
    return Level_WARNING_instance;
  }
  function Level_ERROR_getInstance() {
    Level_initEntries();
    return Level_ERROR_instance;
  }
  function Level_NONE_getInstance() {
    Level_initEntries();
    return Level_NONE_instance;
  }
  function Module(_createdAtStart) {
    _createdAtStart = _createdAtStart === VOID ? false : _createdAtStart;
    this.z2g_1 = _createdAtStart;
    this.a2h_1 = KoinPlatformTools_instance.f2h();
    var tmp = this;
    // Inline function 'kotlin.collections.hashSetOf' call
    tmp.b2h_1 = HashSet_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp_0.c2h_1 = HashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.hashSetOf' call
    tmp_1.d2h_1 = HashSet_init_$Create$();
    var tmp_2 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_2.e2h_1 = ArrayList_init_$Create$();
  }
  protoOf(Module).g2h = function (instanceFactory) {
    var def = instanceFactory.m2g_1;
    var mapping = indexKey(def.u2f_1, def.v2f_1, def.t2f_1);
    this.h2h(mapping, instanceFactory);
  };
  protoOf(Module).i2h = function (instanceFactory) {
    this.b2h_1.e(instanceFactory);
  };
  protoOf(Module).h2h = function (mapping, factory) {
    // Inline function 'kotlin.collections.set' call
    this.c2h_1.b2(mapping, factory);
  };
  protoOf(Module).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof Module))
      THROW_CCE();
    if (!(this.a2h_1 === other.a2h_1))
      return false;
    return true;
  };
  protoOf(Module).hashCode = function () {
    return getStringHashCode(this.a2h_1);
  };
  function flatten(modules) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.collections.mutableSetOf' call
    var this_0 = LinkedHashSet_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'org.koin.core.module.flatten.<anonymous>' call
    flatten$flat(modules, this_0);
    return this_0;
  }
  function overrideError(factory, mapping) {
    throw new DefinitionOverrideException('Already existing definition for ' + factory.m2g_1.toString() + ' at ' + mapping);
  }
  function flatten$flat(modules, newModules) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = modules.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'org.koin.core.module.flatten.flat.<anonymous>' call
      // Inline function 'kotlin.collections.plusAssign' call
      newModules.e(element);
      flatten$flat(element.e2h_1, newModules);
    }
  }
  function getFirstValue($this, clazz) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = $this.j2h_1.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'org.koin.core.parameter.ParametersHolder.getFirstValue.<anonymous>' call
        if (clazz.q9(element)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var tmp0_safe_receiver = tmp$ret$1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'org.koin.core.parameter.ParametersHolder.getFirstValue.<anonymous>' call
      tmp = !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function getIndexedValue($this, clazz) {
    // Inline function 'kotlin.takeIf' call
    var this_0 = $this.j2h_1.p($this.l2h_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'org.koin.core.parameter.ParametersHolder.getIndexedValue.<anonymous>' call
    if (clazz.q9(this_0)) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'org.koin.core.parameter.ParametersHolder.getIndexedValue.<anonymous>' call
      tmp_0 = !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
    }
    var currentValue = tmp_0;
    if (!(currentValue == null)) {
      $this.m2h();
    }
    return currentValue;
  }
  function ParametersHolder(_values, useIndexedValues) {
    var tmp;
    if (_values === VOID) {
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp = ArrayList_init_$Create$();
    } else {
      tmp = _values;
    }
    _values = tmp;
    useIndexedValues = useIndexedValues === VOID ? null : useIndexedValues;
    this.j2h_1 = _values;
    this.k2h_1 = useIndexedValues;
    this.l2h_1 = 0;
  }
  protoOf(ParametersHolder).n2h = function (clazz) {
    var tmp;
    if (this.j2h_1.o()) {
      tmp = null;
    } else {
      var tmp_0;
      switch (this.k2h_1) {
        case null:
          var tmp1_elvis_lhs = getIndexedValue(this, clazz);
          tmp_0 = tmp1_elvis_lhs == null ? getFirstValue(this, clazz) : tmp1_elvis_lhs;
          break;
        case true:
          tmp_0 = getIndexedValue(this, clazz);
          break;
        default:
          tmp_0 = getFirstValue(this, clazz);
          break;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(ParametersHolder).m2h = function () {
    if (this.l2h_1 < get_lastIndex(this.j2h_1)) {
      this.l2h_1 = this.l2h_1 + 1 | 0;
    }
  };
  protoOf(ParametersHolder).toString = function () {
    return 'DefinitionParameters' + toString_0(toList_0(this.j2h_1));
  };
  function emptyParametersHolder() {
    return new ParametersHolder();
  }
  function _q(name) {
    return new StringQualifier(name);
  }
  function named(name) {
    return new StringQualifier(name);
  }
  function StringQualifier(value) {
    this.o2h_1 = value;
  }
  protoOf(StringQualifier).v = function () {
    return this.o2h_1;
  };
  protoOf(StringQualifier).toString = function () {
    return this.o2h_1;
  };
  protoOf(StringQualifier).hashCode = function () {
    return getStringHashCode(this.o2h_1);
  };
  protoOf(StringQualifier).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof StringQualifier))
      return false;
    var tmp0_other_with_cast = other instanceof StringQualifier ? other : THROW_CCE();
    if (!(this.o2h_1 === tmp0_other_with_cast.o2h_1))
      return false;
    return true;
  };
  function addAllEagerInstances($this, module_0) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = module_0.b2h_1.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'org.koin.core.registry.InstanceRegistry.addAllEagerInstances.<anonymous>' call
      // Inline function 'kotlin.collections.set' call
      var this_0 = $this.v2e_1;
      var key = element.hashCode();
      this_0.b2(key, element);
    }
  }
  function loadModule($this, module_0, allowOverride) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = module_0.c2h_1.t().g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'org.koin.core.registry.InstanceRegistry.loadModule.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var mapping = element.u();
      // Inline function 'kotlin.collections.component2' call
      var factory = element.v();
      $this.p2h(allowOverride, mapping, factory);
    }
  }
  function createEagerInstances($this, instances) {
    var defaultContext = new InstanceContext($this.t2e_1.r2e_1, $this.t2e_1.n2e_1.a2f_1);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = instances.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'org.koin.core.registry.InstanceRegistry.createEagerInstances.<anonymous>' call
      element.n2g(defaultContext);
    }
  }
  function InstanceRegistry(_koin) {
    this.t2e_1 = _koin;
    this.u2e_1 = KoinPlatformTools_instance.q2h();
    var tmp = this;
    // Inline function 'kotlin.collections.hashMapOf' call
    tmp.v2e_1 = HashMap_init_$Create$();
  }
  protoOf(InstanceRegistry).w2e = function (modules, allowOverride) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = modules.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'org.koin.core.registry.InstanceRegistry.loadModules.<anonymous>' call
      loadModule(this, element, allowOverride);
      addAllEagerInstances(this, element);
    }
  };
  protoOf(InstanceRegistry).g2f = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.v2e_1.a2();
    var tmp$ret$0 = copyToArray(this_0);
    var instances = arrayListOf(tmp$ret$0.slice());
    this.v2e_1.s1();
    createEagerInstances(this, instances);
  };
  protoOf(InstanceRegistry).r2h = function (allowOverride, mapping, factory, logWarning) {
    if (this.u2e_1.w1(mapping)) {
      if (!allowOverride) {
        overrideError(factory, mapping);
      } else {
        if (logWarning) {
          this.t2e_1.r2e_1.w2g("(+) override index '" + mapping + "' -> '" + factory.m2g_1.toString() + "'");
        }
      }
    }
    this.t2e_1.r2e_1.e2f("(+) index '" + mapping + "' -> '" + factory.m2g_1.toString() + "'");
    // Inline function 'kotlin.collections.set' call
    this.u2e_1.b2(mapping, factory);
  };
  protoOf(InstanceRegistry).p2h = function (allowOverride, mapping, factory, logWarning, $super) {
    logWarning = logWarning === VOID ? true : logWarning;
    var tmp;
    if ($super === VOID) {
      this.r2h(allowOverride, mapping, factory, logWarning);
      tmp = Unit_instance;
    } else {
      tmp = $super.r2h.call(this, allowOverride, mapping, factory, logWarning);
    }
    return tmp;
  };
  protoOf(InstanceRegistry).s2h = function (clazz, qualifier, scopeQualifier) {
    var indexKey_0 = indexKey(clazz, qualifier, scopeQualifier);
    return this.u2e_1.y1(indexKey_0);
  };
  protoOf(InstanceRegistry).t2h = function (qualifier, clazz, scopeQualifier, instanceContext) {
    var tmp0_safe_receiver = this.s2h(clazz, qualifier, scopeQualifier);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.n2g(instanceContext);
    return (tmp == null ? true : !(tmp == null)) ? tmp : null;
  };
  protoOf(InstanceRegistry).m2f = function () {
    return this.u2e_1.j();
  };
  function PropertyRegistry(_koin) {
    this.u2h_1 = _koin;
    this.v2h_1 = KoinPlatformTools_instance.q2h();
  }
  function loadModule_0($this, module_0) {
    $this.y2e_1.n(module_0.d2h_1);
  }
  function Companion_1() {
    Companion_instance_1 = this;
    this.b2g_1 = '_root_';
    this.c2g_1 = _q('_root_');
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function ScopeRegistry(_koin) {
    Companion_getInstance_1();
    this.x2e_1 = _koin;
    this.y2e_1 = HashSet_init_$Create$();
    this.z2e_1 = KoinPlatformTools_instance.q2h();
    this.a2f_1 = new Scope(Companion_getInstance_1().c2g_1, '_root_', true, this.x2e_1);
    this.y2e_1.e(this.a2f_1.w2h_1);
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.z2e_1;
    var key = this.a2f_1.x2h_1;
    var value = this.a2f_1;
    this_0.b2(key, value);
  }
  protoOf(ScopeRegistry).b2f = function (modules) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = modules.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'org.koin.core.registry.ScopeRegistry.loadScopes.<anonymous>' call
      loadModule_0(this, element);
    }
  };
  function resolveInstance($this, qualifier, clazz, parameterDef) {
    if ($this.e2i_1) {
      throw new ClosedScopeException("Scope '" + $this.x2h_1 + "' is closed");
    }
    var parameters = parameterDef == null ? null : parameterDef();
    var localDeque = null;
    if (!(parameters == null)) {
      var tmp = $this.z2h_1.r2e_1;
      var tmp_0 = Level_DEBUG_getInstance();
      tmp.y2g(tmp_0, Scope$resolveInstance$lambda(parameters));
      var tmp1_elvis_lhs = $this.d2i_1.os();
      var tmp_1;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_0 = ArrayDeque_init_$Create$();
        // Inline function 'kotlin.contracts.contract' call
        $this.d2i_1.d2e(this_0);
        tmp_1 = this_0;
      } else {
        tmp_1 = tmp1_elvis_lhs;
      }
      localDeque = tmp_1;
      localDeque.wc(parameters);
    }
    var instanceContext = new InstanceContext($this.z2h_1.r2e_1, $this, parameters);
    var value = resolveValue($this, qualifier, clazz, instanceContext, parameterDef);
    if (!(localDeque == null)) {
      $this.z2h_1.r2e_1.e2f('| << parameters');
      localDeque.zc();
    }
    return value;
  }
  function resolveValue($this, qualifier, clazz, instanceContext, parameterDef) {
    var tmp0_elvis_lhs = $this.z2h_1.o2e_1.t2h(qualifier, clazz, $this.w2h_1, instanceContext);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'org.koin.core.scope.Scope.resolveValue.<anonymous>' call
      $this.z2h_1.r2e_1.e2f("|- ? t:'" + getFullName(clazz) + "' - q:'" + toString(qualifier) + "' look in injected parameters");
      var tmp0_safe_receiver = $this.d2i_1.os();
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.vc();
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n2h(clazz);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'org.koin.core.scope.Scope.resolveValue.<anonymous>' call
      var tmp_1;
      if (!$this.y2h_1) {
        $this.z2h_1.r2e_1.e2f("|- ? t:'" + getFullName(clazz) + "' - q:'" + toString(qualifier) + "' look at scope source");
        var tmp0_safe_receiver_0 = $this.b2i_1;
        var tmp_2;
        if (tmp0_safe_receiver_0 == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'org.koin.core.scope.Scope.resolveValue.<anonymous>.<anonymous>' call
          var tmp_3;
          if (clazz.q9(tmp0_safe_receiver_0) && qualifier == null) {
            var tmp_4 = $this.b2i_1;
            tmp_3 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : null;
          } else {
            tmp_3 = null;
          }
          tmp_2 = tmp_3;
        }
        tmp_1 = tmp_2;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp_5;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'org.koin.core.scope.Scope.resolveValue.<anonymous>' call
      $this.z2h_1.r2e_1.e2f("|- ? t:'" + getFullName(clazz) + "' - q:'" + toString(qualifier) + "' look in other scopes");
      tmp_5 = findInOtherScope($this, clazz, qualifier, parameterDef);
    } else {
      tmp_5 = tmp2_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_5;
    var tmp_6;
    if (tmp3_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$8;
      // Inline function 'org.koin.core.scope.Scope.resolveValue.<anonymous>' call
      if (!(parameterDef == null)) {
        $this.d2i_1.w3();
        $this.z2h_1.r2e_1.e2f('|- << parameters');
      }
      throwDefinitionNotFound($this, qualifier, clazz);
      tmp_6 = tmp$ret$8;
    } else {
      tmp_6 = tmp3_elvis_lhs;
    }
    return tmp_6;
  }
  function findInOtherScope($this, clazz, qualifier, parameters) {
    var instance = null;
    var tmp0_iterator = $this.a2i_1.g();
    $l$loop: while (tmp0_iterator.h()) {
      var scope = tmp0_iterator.i();
      instance = scope.f2i(clazz, qualifier, parameters);
      if (!(instance == null))
        break $l$loop;
    }
    return instance;
  }
  function throwDefinitionNotFound($this, qualifier, clazz) {
    var tmp;
    if (qualifier == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'org.koin.core.scope.Scope.throwDefinitionNotFound.<anonymous>' call
      tmp = " and qualifier '" + toString(qualifier) + "'";
    }
    var tmp1_elvis_lhs = tmp;
    var qualifierString = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    throw new NoBeanDefFoundException("No definition found for type '" + getFullName(clazz) + "'" + qualifierString + '. Check your Modules configuration and add missing type and/or qualifier!');
  }
  function Scope$resolveInstance$lambda($parameters) {
    return function () {
      return '| >> parameters ' + toString($parameters) + ' ';
    };
  }
  function Scope(scopeQualifier, id, isRoot, _koin) {
    isRoot = isRoot === VOID ? false : isRoot;
    this.w2h_1 = scopeQualifier;
    this.x2h_1 = id;
    this.y2h_1 = isRoot;
    this.z2h_1 = _koin;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.a2i_1 = ArrayList_init_$Create$();
    this.b2i_1 = null;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_0.c2i_1 = ArrayList_init_$Create$();
    this.d2i_1 = new ThreadLocalRef();
    this.e2i_1 = false;
  }
  protoOf(Scope).f2i = function (clazz, qualifier, parameters) {
    var tmp;
    try {
      tmp = this.g2i(clazz, qualifier, parameters);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ClosedScopeException) {
        var e = $p;
        this.z2h_1.r2e_1.e2f('* Scope closed - no instance found for ' + getFullName(clazz) + ' on scope ' + this.toString());
        tmp_0 = null;
      } else {
        if ($p instanceof NoBeanDefFoundException) {
          var e_0 = $p;
          this.z2h_1.r2e_1.e2f("* No instance found for type '" + getFullName(clazz) + "' on scope '" + this.toString() + "'");
          tmp_0 = null;
        } else {
          throw $p;
        }
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  protoOf(Scope).g2i = function (clazz, qualifier, parameters) {
    var tmp;
    if (this.z2h_1.r2e_1.o2f(Level_DEBUG_getInstance())) {
      var tmp_0;
      if (qualifier == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'org.koin.core.scope.Scope.get.<anonymous>' call
        tmp_0 = " with qualifier '" + toString(qualifier) + "'";
      }
      var tmp1_elvis_lhs = tmp_0;
      var qualifierString = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      var scopeId = this.y2h_1 ? '' : "- scope:'" + this.x2h_1;
      this.z2h_1.r2e_1.n2f(Level_DEBUG_getInstance(), "|- '" + getFullName(clazz) + "'" + qualifierString + ' ' + scopeId + '...');
      var start = KoinPlatformTimeTools_instance.f2f();
      var instance = resolveInstance(this, qualifier, clazz, parameters);
      var stop = KoinPlatformTimeTools_instance.f2f();
      // Inline function 'kotlin.Long.div' call
      var duration = stop.m2(start).d3() / 1000000.0;
      this.z2h_1.r2e_1.n2f(Level_DEBUG_getInstance(), "|- '" + getFullName(clazz) + "' in " + duration + ' ms');
      tmp = instance;
    } else {
      tmp = resolveInstance(this, qualifier, clazz, parameters);
    }
    return tmp;
  };
  protoOf(Scope).toString = function () {
    return "['" + this.x2h_1 + "']";
  };
  function Companion_2() {
    this.h2i_1 = 1000000.0;
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function module_0(createdAtStart, moduleDeclaration) {
    createdAtStart = createdAtStart === VOID ? false : createdAtStart;
    var module_0 = new Module(createdAtStart);
    moduleDeclaration(module_0);
    return module_0;
  }
  function get_classNames() {
    _init_properties_KClassExt_kt__5ro5b2();
    return classNames;
  }
  var classNames;
  function getFullName(_this__u8e3s4) {
    _init_properties_KClassExt_kt__5ro5b2();
    var tmp0_elvis_lhs = get_classNames().y1(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? saveCache(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function saveCache(_this__u8e3s4) {
    _init_properties_KClassExt_kt__5ro5b2();
    var name = KoinPlatformTools_instance.i2i(_this__u8e3s4);
    // Inline function 'kotlin.collections.set' call
    get_classNames().b2(_this__u8e3s4, name);
    return name;
  }
  var properties_initialized_KClassExt_kt_dizwhw;
  function _init_properties_KClassExt_kt__5ro5b2() {
    if (!properties_initialized_KClassExt_kt_dizwhw) {
      properties_initialized_KClassExt_kt_dizwhw = true;
      classNames = KoinPlatformTools_instance.q2h();
    }
  }
  function register($this, koinApplication) {
    if (!($this.j2i_1 == null)) {
      throw new KoinAppAlreadyStartedException('A Koin Application has already been started');
    }
    $this.j2i_1 = koinApplication.h2f_1;
  }
  function GlobalContext() {
    this.j2i_1 = null;
  }
  protoOf(GlobalContext).os = function () {
    var tmp0_elvis_lhs = this.j2i_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'KoinApplication has not been started';
      throw IllegalStateException_init_$Create$(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(GlobalContext).s2f = function (appDeclaration) {
    var koinApplication = Companion_instance.j2f();
    register(this, koinApplication);
    appDeclaration(koinApplication);
    return koinApplication;
  };
  var GlobalContext_instance;
  function GlobalContext_getInstance() {
    return GlobalContext_instance;
  }
  function KoinPlatformTimeTools() {
  }
  protoOf(KoinPlatformTimeTools).f2f = function () {
    return _Duration___get_inWholeNanoseconds__impl__r5x4mr(ValueTimeMark__elapsedNow_impl_eonqvs(Monotonic_instance.ub()));
  };
  var KoinPlatformTimeTools_instance;
  function KoinPlatformTimeTools_getInstance() {
    return KoinPlatformTimeTools_instance;
  }
  function KoinPlatformTools() {
  }
  protoOf(KoinPlatformTools).p2g = function (e) {
    return e.toString() + toString_0(split(Exception_init_$Create$().toString(), ['\n']));
  };
  protoOf(KoinPlatformTools).i2i = function (kClass) {
    var tmp0_elvis_lhs = kClass.p9();
    return tmp0_elvis_lhs == null ? 'KClass@' + kClass.hashCode() : tmp0_elvis_lhs;
  };
  protoOf(KoinPlatformTools).f2h = function () {
    return getNumberHashCode(Default_getInstance().ve()).toString();
  };
  protoOf(KoinPlatformTools).k2i = function () {
    return LazyThreadSafetyMode_NONE_getInstance();
  };
  protoOf(KoinPlatformTools).q2f = function () {
    return GlobalContext_instance;
  };
  protoOf(KoinPlatformTools).u2g = function (lock, block) {
    return block();
  };
  protoOf(KoinPlatformTools).q2h = function () {
    return ConcurrentMutableMap_init_$Create$();
  };
  var KoinPlatformTools_instance;
  function KoinPlatformTools_getInstance() {
    return KoinPlatformTools_instance;
  }
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_2 = new Companion_2();
  GlobalContext_instance = new GlobalContext();
  KoinPlatformTimeTools_instance = new KoinPlatformTimeTools();
  KoinPlatformTools_instance = new KoinPlatformTools();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Kind_Singleton_getInstance;
  _.$_$.b = Companion_getInstance_1;
  _.$_$.c = KoinPlatformTools_instance;
  _.$_$.d = getKoin;
  _.$_$.e = KoinComponent;
  _.$_$.f = KoinScopeComponent;
  _.$_$.g = startKoin;
  _.$_$.h = BeanDefinition;
  _.$_$.i = KoinDefinition;
  _.$_$.j = SingleInstanceFactory;
  _.$_$.k = named;
  _.$_$.l = module_0;
  //endregion
  return _;
}));
